import { styled } from "@mui/material/styles";

const StyledPayments = styled("div")(
  ({ theme }) => `
   .payments-container {
     display: flex;
     gap: 20px;
     width: 100%;
     @media screen and (max-width: 800px) {
       flex-direction: column;
     }
   }
   .payments-wrap-1 {
     padding: 20px;
     background: ${theme.palette.customColor.white};
     width: 30%;
     @media screen and (max-width: 800px) {
       width: calc(100% - 40px);
     }  
   }
   .payments-wrap-2 {
     padding: 20px;
     background: ${theme.palette.customColor.white};
     width: 70%;
     @media screen and (max-width: 800px) {
       width: calc(100% - 40px);
     }
   }
   .earning-header {
     font-family: Lexend;
     color: ${theme.palette.primary.main};
     font-weight: 500;
     font-size: 20px;
     font-style: normal;
     line-height: 100%;
     @media screen and (max-width: 600px) {
       font-size: 16px;
     }
   }
   .current-earning-header {
     font-family: Lexend;
     color: ${theme.palette.customColor.secondarySecond};
     font-weight: 400;
     font-size: 12px;
     font-style: normal;
     line-height: 16px;
   }
   .earning-wrap {
     display: flex;
     flex-direction: column;
     gap: 20px;
   }
   .current-earning-wrapper {
     display: flex;
     flex-direction: column;
     gap: 10px;
     @media screen and (max-width: 800px) {
       flex-direction: row;
       justify-content: space-between;
       align-items: center;
     }
      @media screen and (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;
     }
   }
   .earning-divider {
     @media screen and (max-width: 800px) {
       height: 0px;
       width: 48px;
       transform: rotate(90deg);
       border-bottom-width: 2px !important;
     }
       @media screen and (max-width: 600px) {
       transform: none;
       width: 100%;
       border-bottom-width: 1px !important;
     }
   }      
   .current-earning {
     display: flex;
     flex-direction: column;
     gap: 10px;
   }  
   .current-earning-value {
     font-family: Lexend;
     color: ${theme.palette.customColor.green};
     font-weight: 500;
     font-size: 24px;
     font-style: normal;
     line-height: 24px;
   }
   .pending-earning-header {
     font-family: Lexend;
     color: ${theme.palette.customColor.secondarySecond};
     font-weight: 400;
     font-size: 12px;
     font-style: normal;
     line-height: 16px;
   }
   .pending-earning {
     display: flex;
     flex-direction: column;
     gap: 10px;
   }  
   .pending-earning-value {
     font-family: Lexend;
     color: ${theme.palette.primary.main};
     font-weight: 500;
     font-size: 24px;
     font-style: normal;
     line-height: 24px;
   }
   .payment-details-head-left {
     width: 100%;
     display: flex;
     flex-direction: column;
     gap: 10px;
   }
   .payment-edit-wrap {
     display: flex;
     justify-content: space-between;
   }
      
   .payment-header {
     font-family: Lexend;
     color: ${theme.palette.primary.main};
     font-weight: 500;
     font-size: 20px;
     font-style: normal;
     line-height: 100%;
     @media screen and (max-width: 600px) {
       font-size: 16px;
     }
   }
   .payment-text {
     font-family: Lexend;
     color: ${theme.palette.customColor.secondarySecond};
     font-weight: 400;
     font-size: 14px;
     font-style: normal;
     line-height: 100%;
     @media screen and (max-width: 600px) {
       font-size: 12px;
     }
   }  
   .edit-payment-btn {
     font-family: Lexend;
     color: ${theme.palette.primary.main};
     font-weight: 400;
     font-size: 14px;
     font-style: normal;
     line-height: 100%;
     cursor: pointer;
     text-decoration: underline;
     @media screen and (max-width: 600px) {
       font-size: 12px;
     }
   }
   .payment-details {
     display: flex;
     flex-direction: row;
     gap: 20%;
     margin-top: 40px;
     @media screen and (max-width: 800px) {
       gap: 80px;
     }
     @media screen and (max-width: 600px) {
       flex-direction: column;
       gap: 10px;
       margin-top: 20px;
     }  
   }
   .payment-details-part1 {
     display: flex;
     flex-direction: row;
     gap: 60px;
     flex-wrap: wrap;
     @media screen and (max-width: 800px) {
       flex-direction: row;
       gap: 80px;
     }
       @media screen and (max-width: 600px) {
       flex-direction: column;
       gap: 10px;
     }
   }        
   .payment-details-part2 {
     display: flex;
     flex-direction: column;
     gap: 30px;
     @media screen and (max-width: 800px) {
       flex-direction: row;
       gap: 80px;
     }
      @media screen and (max-width: 600px) {
       flex-direction: column;
       gap: 10px;
     }  
   }
   .payment-details-header {
     font-family: Lexend;
     color: ${theme.palette.customColor.secondarySecond};
     font-weight: 400;
     font-size: 12px;
     font-style: normal;
     line-height: 16px;
   }
   .payment-details-value {
     font-family: Lexend;
     color: ${theme.palette.primary.main};
     font-weight: 400;
     font-size: 14px;
     font-style: normal;
     line-height: 100%;
     word-break: break-all;
     max-width: 200px;
     @media screen and (max-width: 600px) {
       font-size: 12px;
     }
   }
   .no-breakdown-wrap {
     padding-bottom: 40px;
     display: flex;
     flex-direction: column;
     gap: 20px;
     justify-content: center;
     align-items: center;
     text-align: center;
   }
   .no-breakdown-header {
     font-family: Lexend;
     color: ${theme.palette.primary.main};
     font-weight: 500;
     font-size: 20px;
     font-style: normal;
     line-height: 100%;
     @media screen and (max-width: 600px) {
       font-size: 16px;
     }
   }  
   .no-breakdown-text {
     font-family: Lexend;
     color: ${theme.palette.customColor.secondarySecond};
     font-weight: 400;
     font-size: 14px;
     font-style: normal;
     line-height: 20px;
     margin-top: 15px;
     @media screen and (max-width: 600px) {
       font-size: 12px;
     }
   }
    .payment-breakdown-wrap {
      background: ${theme.palette.customColor.white};
      margin-top: 20px;
    }
    .payment-breakdown-header {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 500;
      font-size: 20px;
      font-style: normal;
      line-height: 100%;
      margin-bottom: 20px;
      padding: 20px;
      @media screen and (max-width: 600px) {
        font-size: 16px;
      }
    }
    .payment-details-block {
      display: flex;
      flex-direction: column;
      gap: 10px;
      @media screen and (max-width: 600px) {
        flex-direction: row;
        justify-content: space-between;
      }
    }       
    
                 
  
`
);

export default StyledPayments;